export default __webpack_public_path__ + "static/media/Pride_of_Altaris_LE.d0212e69.jpg";